export default "__VITE_ASSET__DdnT1T2o__"